export * from './stuck-programs.component';



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/stuck-programs/index.ts